import strings from 'utils/strings'
import * as PROPS from 'constants/spProperties'
import { mapFrom } from 'utils/functional'

const propNames = {
  [PROPS.DESCRIPTION]: strings.description,
  [PROPS.ID]: strings.id,
  [PROPS.STATUS]: strings.status,
  [PROPS.TABLE_DIM_LENGTH]: strings.table_dim_length,
  [PROPS.TABLE_DIM_2D_3D]: strings.table_dim_2d_3d,
  [PROPS.Z_SIGN]: strings.z_sign,
  [PROPS.X_SIGN]: strings.y_sign,
  [PROPS.Y_SIGN]: strings.x_sign,
  [PROPS.Z_BYTE]: strings.z_byte,
  [PROPS.VALUE]: strings.value,
  [PROPS.PARAMETER_VERSION]: strings.parameter_version,
  [PROPS.Modal_NUMBER]: strings.Modal_number,
  [PROPS.LOGICAL_SLOT]: strings.logical_slot,
  [PROPS.ROWID]: strings.rowid,
  [PROPS.PARM_CHECKSUM_OFFSET]: strings.parm_checksum_offset,
  [PROPS.PARM_ADDRESS]: strings.parm_address,
  [PROPS.PARM_SIZE]: strings.parm_size,
  [PROPS.EXTRA_BLOCK_1_ADDRESS]: strings.extra_block_1_address,
  [PROPS.EXTRA_BLOCK_1_SIZE]: strings.extra_block_1_size,
  [PROPS.EXTRA_BLOCK_2_ADDRESS]: strings.extra_block_2_address,
  [PROPS.EXTRA_BLOCK_2_SIZE]: strings.extra_block_2_size,
  [PROPS.EXTRA_BLOCK_3_ADDRESS]: strings.extra_block_3_address,
  [PROPS.EXTRA_BLOCK_3_SIZE]: strings.extra_block_3_size,
  [PROPS.MODE]: strings.mode,
  [PROPS.PRIORITY]: strings.priority,
  [PROPS.INVERTED]: strings.inverted,
  [PROPS.LENGTH]: strings.length,
  [PROPS.OFFSET]: strings.offset,
  [PROPS.TYPE]: strings.type,
  [PROPS.PHYSICAL_SLOT]: strings.physical_slot,
  [PROPS.AI_LS]: strings.ai_ls,
  [PROPS.DO_LS]: strings.do_ls,
  [PROPS.AI]: strings.ai,
  [PROPS.DO]: strings.do,
  [PROPS.COMPARE]: strings.compare,
  [PROPS.INTERCEPT]: strings.intercept,
  [PROPS.REACTION]: strings.reaction,
  [PROPS.PC_INC]: strings.pc_inc,
  [PROPS.PC_DEC]: strings.pc_dec,
  [PROPS.FAULT_INTERCEPT]: strings.fault_intercept,
  [PROPS.FAULT_REACTION]: strings.fault_reaction,
  [PROPS.FAULT_PC_INC]: strings.fault_pc_inc,
  [PROPS.FAULT_PC_DEC]: strings.fault_pc_dec,
  [PROPS.DTC_J1587_SID]: strings.dtc_j1587_sid,
  [PROPS.DTC_J1939_SPN]: strings.dtc_j1939_spn,
  [PROPS.DTC_J1587_FMI]: strings.dtc_j1587_fmi,
  [PROPS.DTC_J1939_FMI]: strings.dtc_j1939_fmi,
  [PROPS.J1587_SID]: strings.j1587_sid,
  [PROPS.J1939_SPN]: strings.j1939_spn,
  [PROPS.J1587_FMI]: strings.j1587_fmi,
  [PROPS.J1939_FMI]: strings.j1939_fmi,
  [PROPS.DTC_REACTION]: strings.dtc_reaction,
  [PROPS.ACQUIRE_LOW]: strings.acquire_low,
  [PROPS.ACQUIRE_HIGH]: strings.acquire_high,
  [PROPS.LOSS_LOW]: strings.loss_low,
  [PROPS.LOSS_HIGH]: strings.loss_high,
  [PROPS.TIMER_SLOT]: strings.timer_slot,
  [PROPS.TASK1]: strings.task1,
  [PROPS.TASK2]: strings.task2,
  [PROPS.TASK3]: strings.task3,
  [PROPS.TASK4]: strings.task4,
  [PROPS.TASK5]: strings.task5,
  [PROPS.TASK6]: strings.task6,
  [PROPS.TASK7]: strings.task7,
  [PROPS.OUTPUT_ID]: strings.output_id,
  [PROPS.BEHAVIOR_CODE]: strings.behavior_code,
  [PROPS.TEST_TIME]: strings.test_time,
  [PROPS.OUTPUT_1]: strings.output_1,
  [PROPS.OUTPUT_2]: strings.output_2,
  [PROPS.OUTPUT_1_CURRENT_SENSE]: strings.output_1_current_sense,
  [PROPS.OUTPUT_2_CURRENT_SENSE]: strings.output_2_current_sense,
  [PROPS.OUTPUT_1_LOW_LIMIT]: strings.output_1_low_limit,
  [PROPS.OUTPUT_2_LOW_LIMIT]: strings.output_2_low_limit,
  [PROPS.OUTPUT_1_HIGH_LIMIT]: strings.output_1_high_limit,
  [PROPS.OUTPUT_2_HIGH_LIMIT]: strings.output_2_high_limit,
  [PROPS.CAN_SLOT]: strings.can_slot,
  [PROPS.PGN]: strings.pgn,
  [PROPS.ADDRESS]: strings.address,
  [PROPS.MESSAGE_ID]: strings.message_id,
  [PROPS.BYTE_OFFSET]: strings.byte_offset,
  [PROPS.UPDATE_RATE]: strings.update_rate,
  [PROPS.RX_TX]: strings.rx_tx,
  [PROPS.UNIQUE_ID]: strings.unique_id,
  [PROPS.MLOGICSLOTNAME]: strings.slot_name,
  [PROPS.PLC_IGN_SLOT]: strings.nplc_ign_block_label,
  [PROPS.ENABLE_CELL_1]: strings.nplc_enable_cell_1_label,
  [PROPS.ENABLE_CELL_2]: strings.nplc_enable_cell_2_label,
  [PROPS.ENABLE_CELL_3]: strings.nplc_enable_cell_3_label,
  // [PROPS.PLC_OUTPUT]: strings.nplc_output_label, PLC_OUTPUT points to the property "rowid" but it is handled differently for PLCs. It is a duplicate of ROWID that other native SPs use, so it cannot be translated here
}

export default mapFrom(propNames)
